import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, Router, RouterState, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { GwcApiOrdersService } from '@src/app/services/gwc-api/orders.service';

import { InstitutionService } from './../institution.service';


@Injectable({
    providedIn: 'root'
})
export class InstitutionOrdersResolver {

    constructor(
        private _institutionService: InstitutionService
    ) { }


    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        console.log('Resolver called');
        const queryParams = this._institutionService.currentOrderQueryParams;
        const filters = queryParams?.filters ?? {};

        return this._institutionService.getInstitutionGraduationOrders(
            route.params.graduation_id,
            queryParams?.page ?? 0,
            queryParams?.size ?? 15,
            'created_at',
            'desc',
            queryParams?.search ?? '',
            { order_status: filters.order_status ?? '' },
            queryParams?.check_optional_reg ?? false,
            queryParams?.filter_by_ineligible ?? false,
            queryParams?.regalia_id ?? queryParams?.regalia_search ?? '',
            queryParams?.show_no_regalia ?? false
        )
    }

}


@Injectable({
    providedIn: 'root'
})
export class InstitutionOrderResolver {

    constructor(
        private _institutionService: InstitutionService,
        private _ordersApi: GwcApiOrdersService,
        private _router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this._ordersApi.getOrder(route.params.order_id).pipe(
            map(order => {
                if (order.orderable_type === 'App\\Models\\BulkOrder') {
                    this._institutionService.setOrder(null);
                    return new RedirectCommand(this._router.parseUrl(
                        `/bulk-orders/bulk-orders/(bulkOrder:${order.order_id})`
                    ));
                }
                this._institutionService.setOrder(order);
                return order;
            })
        )
    }

}


